import React from 'react'
import Content from './MasterFilterPopover'

const SearchView = ({ searchVerbatim, accounts }) => {
  return (
    <Content
      accounts={accounts}
      searchVerbatim={searchVerbatim}
    />
  )
}

export default SearchView
